import React from 'react'
import {Icon} from '@chakra-ui/react'

const NumberAbsoluteIcon = (props) => {
    return (
        <Icon viewBox="0 0 20 20" {...props}>
            <circle cx="9" cy="9" r="9" fill="#D11B59" />
            <path
                d="M5.53047 5.9C7.44047 5.9 8.56047 7.13 8.56047 9.38C8.56047 11.78 7.16047 13.1 5.13047 13.1C4.43047 13.1 3.76047 12.95 3.29047 12.65L3.77047 11.67C4.15047 11.92 4.61047 12.01 5.10047 12.01C6.42047 12.01 7.25047 11.19 7.25047 9.6V9.59C6.83047 10.08 6.16047 10.32 5.38047 10.32C4.00047 10.32 2.97047 9.48 2.97047 8.17C2.97047 6.78 4.10047 5.9 5.53047 5.9ZM5.63047 9.3C6.47047 9.3 7.05047 8.79 7.05047 8.1C7.05047 7.44 6.53047 6.92 5.60047 6.92C4.79047 6.92 4.23047 7.38 4.23047 8.11C4.23047 8.84 4.78047 9.3 5.63047 9.3ZM11.8 5.9C13.71 5.9 14.83 7.13 14.83 9.38C14.83 11.78 13.43 13.1 11.4 13.1C10.7 13.1 10.03 12.95 9.56 12.65L10.04 11.67C10.42 11.92 10.88 12.01 11.37 12.01C12.69 12.01 13.52 11.19 13.52 9.6V9.59C13.1 10.08 12.43 10.32 11.65 10.32C10.27 10.32 9.24 9.48 9.24 8.17C9.24 6.78 10.37 5.9 11.8 5.9ZM11.9 9.3C12.74 9.3 13.32 8.79 13.32 8.1C13.32 7.44 12.8 6.92 11.87 6.92C11.06 6.92 10.5 7.38 10.5 8.11C10.5 8.84 11.05 9.3 11.9 9.3Z"
                fill="white"
            />
        </Icon>
    )
}

export default NumberAbsoluteIcon
